import {
    APP_DIRECTION,
    APP_LANGUAGE,
    AUTH_STATUS,
    USER_DATA,
    PUBLISH_DATA,
    CALENDERـLANG,
    KIOSK_DATA,
    PUBLISHES_DATA,
    WORKSPACE_DATA,
    EXPIRE,
    PORTAL_DATA,
    ANSWER_DETIAL,
} from './actions';
import { AuthStatus, ReduxAction, ReduxState } from 'interface';
import { uCheckLang } from '../ucheck/ucheck.lang';
import { Direction } from 'interface';
import { __Calender } from 'interface/redux';
import { kioskData, portalData, publishDataStatus, userData } from 'scripts/storage';

export const initial_state: ReduxState = {
    lang: uCheckLang,
    authStatus: AuthStatus.pending,
    direction: Direction.rtl,
    userData: userData.get() ? userData.get() : null,
    publishData: null,
    workspacesData: null,
    publishesData: publishDataStatus.isStored() ? [] : null,
    calender: __Calender.jalali,
    kioskData: kioskData.get(),
    expired: false,
    // kioskData: { publish: 298, form: 155 },
    // kioskData: null,
    portalPublishData: portalData.get(),
    answerDetail: null,
};

function reducer(state: ReduxState = initial_state, action: ReduxAction<any>): ReduxState {
    switch (action.type) {
        case AUTH_STATUS:
            return { ...state, authStatus: action.payload };
        case USER_DATA:
            return { ...state, userData: action.payload };
        case APP_LANGUAGE:
            return { ...state, lang: action.payload };
        case APP_DIRECTION:
            return { ...state, direction: action.payload };
        case PUBLISH_DATA:
            return { ...state, publishData: action.payload };
        case KIOSK_DATA:
            return { ...state, kioskData: action.payload };
        case PORTAL_DATA:
            return { ...state, portalPublishData: action.payload };
        case CALENDERـLANG:
            return { ...state, calender: action.payload };
        case PUBLISHES_DATA:
            return { ...state, publishesData: action.payload };
        case WORKSPACE_DATA:
            return { ...state, workspacesData: action.payload };
        case EXPIRE:
            return { ...state, expired: action.payload };
        case ANSWER_DETIAL:
            return { ...state, answerDetail: action.payload };
        default:
            return state;
    }
}

export default reducer;
